document.addEventListener("DOMContentLoaded", function () {
  // Check if we're on a product page by checking the URL path
  const isProductPage = window.location.pathname.includes("/products/");

  if (isProductPage) {
    // Find and remove the payment logos container
    const paymentContainer = document.getElementById("paymentLogos");
    if (paymentContainer) {
      paymentContainer.remove();
    }
  }
});
